import { RigFracGroupBy } from "constants/charts.enums";
import type { RigFracFocusAttribute } from "utils/color/focusColorSync";

// The rig/frac attribute keys shared by /values, the tile tags, the layer
// filter, Colour By and the chart's group-by mapping.
export const RIG_FRAC_FIELD = {
  Operator: "operator",
  Basin: "basin",
  SubBasin: "subBasin",
  Country: "country",
  StateProvince: "stateProvince",
  County: "county",
  LocationType: "locationType",
  RigTrajectory: "rigTrajectory"
} as const;

export type RigFracField = (typeof RIG_FRAC_FIELD)[keyof typeof RIG_FRAC_FIELD];

// The rig/frac attribute each chart group-by dimension maps to. Total, so a
// dimension with no focus attribute resolves to "no attribute" explicitly
// instead of silently falling through to a real one.
export const RIG_FRAC_CHART_GROUP_BY_ATTRIBUTE: Record<
  RigFracGroupBy,
  Maybe<RigFracFocusAttribute>
> = {
  [RigFracGroupBy.Operator]: "operator",
  [RigFracGroupBy.Basin]: "basin",
  [RigFracGroupBy.SubBasin]: "subBasin",
  [RigFracGroupBy.Country]: "country",
  [RigFracGroupBy.StateProvince]: "stateProvince",
  [RigFracGroupBy.County]: "county",
  [RigFracGroupBy.LocationType]: undefined,
  // EVA-107. No well focus maps to trajectory, so a trajectory-grouped chart
  // takes palette colours.
  [RigFracGroupBy.RigTrajectory]: undefined
};

// Same caps chart-svc enforces (MaxFocusBinKeys, MaxFocusBinValueLength).
export const RIG_FRAC_FOCUS_BIN_KEY_LIMIT = 10_000;
export const RIG_FRAC_FOCUS_BIN_VALUE_MAX_LENGTH = 1_000;
